<template>

    <div v-if="type.toLowerCase() === 'textarea'" class="input" >
        <div class="input__textarea_title">
            <span class="input__textarea_label">{{ label }}</span>
            <span class="input__textarea_maxlength">{{ $t('input.MAX_CHARACTERS', { maxlength }) }}</span>
        </div>
        <textarea class="input__textarea" :maxlength="maxlength" :id="id" :placeholder="placeholder" :value="modelValue" :disabled="disabled" @input="updateValue" ></textarea>
        <div :style="{display: 'flex', flexDirection: 'column', gap: '6px'}">
            <span v-if="isError && errorMessage" class="input__errorMessage">{{ errorMessage }}</span>
            <span v-if="supportText?.length" class="input__supportText"><i v-if="supportTextIcon" class="material-icons">{{ supportTextIcon }}</i> {{ supportText }}</span>
        </div>
    </div>

    <template v-else-if="type.toLowerCase() === 'password'">
        <div class="password_container">
            <div  class="input" >
                <input :class="`input__input`" :type="showPassword ? 'text' : 'password'" :placeholder="placeholder" :id="id" :disabled="disabled" :value="modelValue" @input="validateCharacter($event)" @focus="modelValue ? true : false" ref="input" />
                <label :class="`input__label${modelValue?.length && '--completed' || ''} ${isError && 'input__label--isError' || ''} ${disabled && 'input__label--disabled' || ''}`"  :for="id">{{ label }}  <span v-if="optional" class="input__optional">{{ $t('input.OPTIONAL') }}</span></label>
                <i @click="showPassword = !showPassword" class="material-icons-outlined input__tooltip">{{ showPassword ? 'visibility_off' : 'visibility'}}</i>
            </div>
            <div v-if="showInvalidCharacter" class="invalid-character"><i class="material-icons">error</i><span>{{ $t('input.PASSWORD_INVALID_CHARACTERS') }}</span></div>
            <span v-if="isError && errorMessage" class="input__errorMessage">{{ errorMessage }}</span>
            <span v-if="supportText?.length" class="input__supportText"><i v-if="supportTextIcon" class="material-icons">{{ supportTextIcon }}</i> {{ supportText }}</span>
        </div>
    </template>

    <template v-else-if="type.toLowerCase() === 'number'">
        <div style="width: 100%;">
            <div class="input">
                <input :class="`input__input`" type="number" :placeholder="placeholder" :id="id" :disabled="disabled" :value="modelValue" @input="updateValue" :min="minNumber" :max="maxNumber" ref="input" />
                <label :class="`input__label${typeof modelValue == 'number'  && '--completed' || ''} ${isError && 'input__label--isError' || ''} ${disabled && 'input__label--disabled' || ''}`"  :for="id">{{ label }}  <span v-if="optional" class="input__optional">{{ $t('input.OPTIONAL') }}</span></label>
                <i @mouseover="showTooltip = true" @mouseleave="showTooltip = false" v-if="tooltipTitle || tooltipMessage" class="material-icons input__tooltip">error</i>
                <ToolTip v-if="showTooltip" :title="tooltipTitle" :message="tooltipMessage" />
                <span :style="{left: ((modelValue.toString().length * 7) + 31) + 'px'}" class="input__labelNextToNumber" v-if="labelNextToNumber && modelValue">{{ labelNextToNumber }}</span>
            </div>
            <span v-if="isError && errorMessage" class="input__errorMessage">{{ errorMessage }}</span>
            <span v-if="supportText?.length" class="input__supportText"><i v-if="supportTextIcon" class="material-icons">{{ supportTextIcon }}</i> {{ supportText }}</span>

        </div>
    </template>

    <template v-else-if="type.toLowerCase() === 'time'">
        <div style="width: 100%;">
            <div class="input">
                <input :class="`input__input`" :type="!modelValue ? 'text' : 'time'" :placeholder="placeholder" :id="id" :disabled="disabled" :value="formatHour(modelValue, 0, gmtDate)" @input="updateValue" min="0" onfocus="(this.type='time')" onblur="if(!this.value) this.type = 'text'" ref="input" />
                <label :class="`input__label${modelValue?.length && '--completed' || ''} ${isError && 'input__label--isError' || ''} ${disabled && 'input__label--disabled' || ''}`"  :for="id">{{ label }}  <span v-if="optional" class="input__optional">{{ $t('input.OPTIONAL') }}</span></label>
                <i @mouseover="showTooltip = true" @mouseleave="showTooltip = false" v-if="tooltipTitle || tooltipMessage" class="material-icons input__tooltip">error</i>
                <ToolTip v-if="showTooltip" :title="tooltipTitle" :message="tooltipMessage" />
            </div>
            <span v-if="isError && errorMessage" class="input__errorMessage">{{ errorMessage }}</span>
            <span v-if="supportText?.length" class="input__supportText"><i v-if=supportTextIcon class="material-icons">{{ supportTextIcon }}</i> {{ supportText }}</span>
        </div>
    </template>

    <template v-else-if="type.toLowerCase() === 'link'">
        <div style="width: 100%;">
            <div  class="input input--link">
                <!-- <i class="material-icons input--link__icon">link</i> -->
                <span class="input--link__label-before-text">{{ labelBeforeText }}</span>
                <input :class="`input__input input--link__input`" type="text" :placeholder="placeholder" :id="id" :disabled="disabled" :value="modelValue" @input="updateValue" @focus="modelValue ? true : false" ref="input" />
                <!-- <label :class="`input__label${modelValue?.length && '--completed' || ''} ${isError && 'input__label--isError' || ''} ${disabled && 'input__label--disabled' || ''}`"  :for="id">{{ label }}  <span v-if="optional" class="input__optional">{{ $t('input.OPTIONAL') }}</span></label> -->
                <!-- <i @mouseover="showTooltip = true" @mouseleave="showTooltip = false" v-if="tooltipTitle || tooltipMessage" class="material-icons input__tooltip">error</i> -->
                <!-- <ToolTip v-if="showTooltip" :title="tooltipTitle" :message="tooltipMessage" /> -->
            </div>
            <span v-if="isError && errorMessage" class="input__errorMessage">{{ errorMessage }}</span>
            <span v-if="supportText?.length" class="input__supportText"><i v-if="supportTextIcon" class="material-icons">{{ supportTextIcon }}</i> {{ supportText }}</span>
        </div>
        
    </template>

    <template v-else>
        <div style="width: 100%;">
            <div  class="input" >
                <input :class="`input__input`" type="text" :placeholder="placeholder" :id="id" :disabled="disabled" :value="modelValue" @input="updateValue" @focus="modelValue ? true : false" ref="input" />
                <label :class="`input__label${modelValue?.length && '--completed' || ''} ${isError && 'input__label--isError' || ''} ${disabled && 'input__label--disabled' || ''}`"  :for="id">{{ label }}  <span v-if="optional" class="input__optional">{{'Opcional'}}</span></label>
                <i @mouseover="showTooltip = true" @mouseleave="showTooltip = false" v-if="tooltipTitle || tooltipMessage" class="material-icons input__tooltip">error</i>
                <ToolTip v-if="showTooltip" :title="tooltipTitle" :message="tooltipMessage" />
            </div>
            <span v-if="isError && errorMessage" class="input__errorMessage">{{ errorMessage }}</span>
            <span v-if="supportText?.length" class="input__supportText"><i v-if="supportTextIcon" class="material-icons">{{ supportTextIcon }}</i> {{ supportText }}</span>
        </div>
        
    </template>
</template>

<script>
import { ref } from 'vue';
import ToolTip from './ToolTip.vue';
import moment from 'moment'

export default {
        props: {
        type: {
            type: String,
            default: 'text'
        },
        label: {
            type: String
        },
        gmtDate: {
            default: 0
        },
        placeholder: {
            type: String
        },
        id: {
            required: true
        },
        isError: {
            type: Boolean
        },
        errorMessage: {
            type: String
        },
        disabled: {
            type: Boolean
        },
        optional: {
            type: Boolean
        },
        supportText: {
            type: String
        },
        supportTextIcon: {
            type: String
        },
        modelValue: {
            required: true,
            default: ''
        },
        tooltipTitle: {
            type: String
        },
        tooltipMessage: {
            type: String
        },
        maxlength: {
            type: Number,
            default: 300
        },
        minNumber: {
            type: Number,
            default: 0
        },
        maxNumber: {
            type: Number,
            default: 100000000
        },
        labelNextToNumber: {
            type: String
        },
        labelBeforeText: {
            type: String
        }
    },
    setup(props, { emit }) {
        const showTooltip = ref(false);
        const showPassword = ref(false)
        const showInvalidCharacter = ref(false)
        const input = ref(null)

        const updateValue = (event) => {
            if (props.modelValue !== event.target.value) {
                event.target.focus()
            }
            if (props.type === 'number') {
                if (event.target.value.includes('-')) {
                    event.target.value = 0
                }
                if (parseInt(event.target.value) > parseInt(props.maxNumber)) {
                    console.log(event.target.value, props.maxNumber)
                    event.target.value = props.maxNumber
                }
                emit('update:modelValue', event.target.value)
                return
            }
            if (props.type === 'time') {
                emit('update:modelValue', formatHour(event.target.value, props.gmtDate, 0))
                return
            }
            emit('update:modelValue', event.target.value)
        }
        
        function formatHour(hora, gmtActual, gmtDeseado) {
            let horaActual
            if (gmtDeseado === 0) {
                horaActual = moment(hora, "HH:mm").utcOffset(gmtActual, true);
            } else {
                horaActual = moment.utc(hora, "HH:mm").utcOffset(gmtActual, true);
            }

            const horaDeseada = horaActual.clone().utcOffset(gmtDeseado);

            const horaFormateada = horaDeseada.format("HH:mm");

            return horaFormateada === 'Invalid date' ? '' : horaFormateada;
        }

        function validateCharacter(event) {
            const passwordPattern = /^[a-z0-9]+$/i
            if (!passwordPattern.test(event.target.value) && event.target.value.length !== 0) {
                event.preventDefault();
                showInvalidCharacter.value = true;
                setTimeout(() => {
                    showInvalidCharacter.value = false;
                }, 2000)
            }
            else {
                emit('update:modelValue', event.target.value)
            }
        }

        return {
            showTooltip,
            showPassword,
            validateCharacter,
            showInvalidCharacter,
            updateValue,
            input,
            formatHour
        };
    },
    components: { ToolTip }
}
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';
textarea{
    resize: vertical;
    width: 100%;
}
.toolTip{
    right: 0;
    z-index: 9999;
}

input[type="time"]::-webkit-calendar-picker-indicator{
    width: 20px;
    height: 20px;
    position: absolute;
    top: 14px;
    right: 28px;
}

input[type=number]::-webkit-inner-spin-button{
    -webkit-appearance: none;
}

::-webkit-datetime-edit-year-field:not([aria-valuenow]),
::-webkit-datetime-edit-month-field:not([aria-valuenow]),
::-webkit-datetime-edit-day-field:not([aria-valuenow]) {
    color: transparent;
}

.password_container{
      .invalid-character{
    width: 206px;
    position: absolute;
    left: 56px;
    top: -40px;
    padding: 8px;
    @include icon-and-text-container;
    background: #fff;
    border: 1px solid;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
    .material-icons{
      position: relative;
      padding-right: 0;
    }
  }
}
.input{
    position: relative;
    width: 100%;
    input::-webkit-input-placeholder {
        transition: color .3s;
        color: transparent;
    }
    input:focus::-webkit-input-placeholder {
        color: #7d7d7d;
    }
    &__tooltip{
        position: absolute;
        right: 28px;
        top: 14px;
        color: $darkgray;
        transform: rotate(180deg);
        transition: all .3s;
        &:hover{
            color: $black;
        }
    }
    &__textarea{
        border-radius: 15px;
        border: none;
        outline: none;
        background-color: $whitegray;
        font-family: 'Open Sans', sans-serif; 
        padding: 22px;
        width: 100%;
        &::placeholder{
            font-size: 12px;
            font-style: italic;
        }
        &_title{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 8px;
        }
        &_label{
            font-weight: 700;
            font-size: 12px;
            color: $black;
        }
        &_maxlength{
            font-size: 11px;
            font-weight: 600;
            color: $lightgray;
        }
    }
    &__labelNextToNumber{
        position: absolute;
        top: 22px;
        font-size: 13px;
        font-weight: 400
    }
    &__supportText{
        font-weight: 600;
        font-size: 10px;
        color: $black;
        padding: 0 28px;
        display: flex;
        align-items: center;
        gap: 6px;
        margin-top: 6px;
        .material-icons{
            font-size: 16px;
        }
    }
    &__input{
        width: 100%;
        background: $whitegray;
        padding: 18px 28px 6px 28px;
        border: none;
        outline: none;
        border-radius: 50px;
        font-size: 13px;
        font-weight: 400;
        line-height: 25px;
        transition: all .2s;
        font-family: 'Open Sans', sans-serif; 
        height: 50px !important;
        &:focus + .input__label{
            transform: translateY(3px);
            font-size: 10px;
            color: $green;
            .input__optional{
                font-size: 10px;
            }
        }   
        &:hover{
            background-color: $lightgray;
        }
        &--error{
            @extend .input__input;
            outline: 1px solid $red;
            &:focus + .input__label{
                transform: translateY(3px);
                font-size: 10px;
                color: $red;
            }
        }
        &:disabled + .input__label{
            opacity: .6;
            font-weight: 600;
        }
        &--date{
            font-size: 0;
            &:focus {
                font-size: 13px;
            }
        }
    }
    &__date_icon{
        position: absolute;
        right: 28px;
        top: 14px;
        cursor: pointer;
    }
    &__calendar{
        width: fit-content;
        background: #FFFFFF;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        border-radius: 5px;
        padding: 16px 14px;
        &_selectMonthAndYear{
            display: flex;
            width: 100%;
            align-items: center;
            justify-content: space-evenly;
            margin-bottom: 10px;
            font-size: 12px;
            span{
                font-weight: 700;
                padding: 6px 18px;
                border-radius: 5px;
                cursor: pointer;
                &:hover{
                    background-color: #ddd;
                }
            }
            .material-icons{
                cursor: pointer;
            }   
        }
        &_grid{
            display: grid;
            grid-template-columns: repeat(7, minmax(21px, 1fr));
            grid-template-rows: repeat(6, minmax(21px, 1fr));
            font-size: 12px;
            text-align: center;
            align-items: center;
            justify-items: center;
            &--day{
                font-weight: 700;
                cursor: default !important;
                &:hover{
                    background-color: inherit !important;
                }
            }
            span{
                cursor: pointer;
                padding: 8px;
                border-radius: 999px;
                width: 100%;
                &:hover{
                    background-color: #ddd;
                }
            }
        }
    }
    &__label{
        cursor: text;
        position: absolute;
        top: 0;
        left: 28px;
        user-select: none;
        transform: translateY(12px);
        transition: transform .5s, color .3s, font-size .5s;
        line-height: 25px;
        font-size: 13px;
        pointer-events: none;
        &--completed{
            @extend .input__label;
            transform: translateY(3px);
            font-size: 10px;
            color: $green;
            .input__optional{
                font-size: 10px;
            }
        }
        &--isError{
            color: $red !important;
        }
        &--disabled{
            opacity: .6;
            color: $black;
        }
    }
    &__errorMessage{
        font-weight: 600;
        font-size: 10px;
        color: $red;
        padding-left: 28px;
        display: flex;
    }
    &__optional{
        font-size: 13px;
        font-style: italic;
        color: #7d7d7d;
        transition: font-size .5s;
    }
    &--link{
        display: flex;
        align-items: center;
        gap: 4px;
        @media(max-width:980px) {
            flex-direction: column;
            align-items: flex-start;
        }
        input::-webkit-input-placeholder {
            color: #7d7d7d;
        }        
        .input__input{
            padding: 8px 16px!important;
        }
        // &__icon{
        //     color: $green;
        // }
        &__label-before-text{
            font-size: 13px;
            font-weight: 600;
            flex-shrink: 0;
            color: $green;
        }
    }
}

</style>